export const gemsReward = 5;
export const visitListLimit = 100;
export const visitListWithNonFriendsLimit = 50;
export const friendRevivalCost = 500;
